import { getTariffVoltageType, getTariffModality } from '@utils/tariff-helpers';

export const getRequiredHistoryFields = (tariffGroup: any) => {
  const voltageType = getTariffVoltageType(String(tariffGroup));
  const productType = getTariffModality(String(tariffGroup));

  if (voltageType === 'LOW_VOLTAGE') {
    return {
      showConsumption: true,
      showPeakConsumption: false,
      showOffPeakConsumption: false,
      showDemand: false,
      showPeakDemand: false,
      showOffPeakDemand: false,
    };
  }

  if (voltageType === 'MEDIUM_VOLTAGE' && (productType === 'BLUE' || productType === 'GREEN')) {
    return {
      showConsumption: false,
      showPeakConsumption: true,
      showOffPeakConsumption: true,
      showDemand: false,
      showPeakDemand: false,
      showOffPeakDemand: false,
    };
  }

  return {
    showConsumption: false,
    showPeakConsumption: false,
    showOffPeakConsumption: false,
    showDemand: false,
    showPeakDemand: false,
    showOffPeakDemand: false,
  };
};
